export default "__VITE_PUBLIC_ASSET__dc59cfee__"